import { render, staticRenderFns } from "./companySelect.vue?vue&type=template&id=530b6920&scoped=true&"
import script from "./companySelect.vue?vue&type=script&lang=js&"
export * from "./companySelect.vue?vue&type=script&lang=js&"
import style0 from "./companySelect.vue?vue&type=style&index=0&id=530b6920&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530b6920",
  null
  
)

export default component.exports